import { Card, CardContent, TextWithDescription } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileData } from '@/entities/profile';

export type ReadonlyInfoCardProps = {
  profile: ProfileData | undefined;
};

export const ReadonlyInfoCard: FC<ReadonlyInfoCardProps> = ({ profile }) => {
  const { t } = useTranslation(['profile']);
  return (
    <Card className={'w-full'}>
      <CardContent className={'grid grid-cols-1 md:grid-cols-2 gap-3'}>
        <TextWithDescription text={t('profile:role')} description={profile?.role?.name || '-'} />
        <TextWithDescription
          text={t('profile:groups')}
          description={
            <div className={'flex flex-wrap gap-2'}>
              {(profile?.userGroups || []).length > 0 ? (
                profile?.userGroups?.map((g) => (
                  <span key={g.id} className={'text-foreground/80 text-sm'}>
                    {g.name}
                  </span>
                ))
              ) : (
                <span className={'text-foreground/50 text-sm'}>{'-'}</span>
              )}
            </div>
          }
        />
      </CardContent>
    </Card>
  );
};
